import React, { useState, useContext } from 'react';

import { Icon } from 'design-system-web';
import {
  FONT_AWESOME_SOLID,
  FONT_AWESOME_REGULAR,
} from 'lane-shared/helpers/constants/icons';
import { ThemeContext } from 'lane-shared/contexts';

import styles from './StarRating.scss';

interface StarRatingProps {
  rating: number;
  onRatingChange: (rating: number) => void;
}

export const StarRating = ({ rating, onRatingChange }: StarRatingProps) => {
  const [hoverRating, setHoverRating] = useState(0);
  const theme = useContext(ThemeContext);

  return (
    <div className={styles.starRating}>
      {[1, 2, 3, 4, 5].map(star => {
        const isFilled = star <= (hoverRating || rating);

        return (
          <button
            key={star}
            type="button"
            className={styles.starButton}
            onMouseEnter={() => setHoverRating(star)}
            onMouseLeave={() => setHoverRating(0)}
            onClick={() => onRatingChange(star)}
          >
            <Icon
              name="star"
              size="large"
              type={isFilled ? FONT_AWESOME_SOLID : FONT_AWESOME_REGULAR}
              style={theme?.primary ? { color: theme.primary } : undefined}
            />
          </button>
        );
      })}
    </div>
  );
};
